import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LtlQuoteRequest } from '@graphql-types';
import { QuoteRequestStatusComponent } from '@ui/quote-request-status/quote-request-status.component';

@Component({
  selector: 'lig-ltl-quote-search-option',
  standalone: true,
  imports: [MatIconModule, QuoteRequestStatusComponent],
  templateUrl: './ltl-quote-search-option.component.html',
  styleUrls: ['./ltl-quote-search-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LtlQuoteSearchOptionComponent {
  option = input.required<LtlQuoteRequest>();
}
